import { DirectUpload } from "@rails/activestorage";

export const DIRECT_UPLOADS_URL = "/rails/active_storage/direct_uploads";

export function csrfToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? "";
}

// Direct-uploads a file and resolves to its blob signed id. The plain-promise primitive shared by
// the Solid upload hooks and non-hook callers; hooks layer their own state on top and pass
// `onProgress` to reflect upload percentage.
export function directUpload(
  file: File,
  url: string = DIRECT_UPLOADS_URL,
  onProgress?: (percent: number) => void,
): Promise<string> {
  return new Promise((resolve, reject) => {
    const upload = new DirectUpload(file, url, {
      directUploadWillStoreFileWithXHR: (xhr: XMLHttpRequest) => {
        xhr.setRequestHeader("X-CSRF-Token", csrfToken());
        if (onProgress) {
          xhr.upload.addEventListener("progress", (event) => {
            if (event.lengthComputable) onProgress(Math.round((event.loaded / event.total) * 100));
          });
        }
      },
    });
    upload.create((error, blob) => {
      if (error || !blob) reject(new Error("upload failed"));
      else resolve(blob.signed_id);
    });
  });
}
